<template>
    <div class="hidden e5-dropdown e5-dropdown-calendar" aria-labelledby="calendar">
        <div class="flex-none">
            <!-- dropdown header -->
            <div class="e5-dropdown-header">

                <div class="e5-dropdown-infotext">
                    <!--                    <div class="truncate">-->
                    <!--                        Tallinn -> Egiptus, Costa del Sol, Argentiina, Los Alamos | Tallinn -> Stockholm, Frankfurt, Egiptus | Tallinn -> Stockholm, Frankfurt, Egiptus-->
                    <!--                    </div>-->
                    <!--                    <div class="truncate">-->
                    <!--                        Riia -> Egiptus, Costa del Sol, Argentiina, Los Alamos | Riia -> Stockholm, Frankfurt, Egiptus | Riia -> Stockholm, Frankfurt, Egiptus-->
                    <!--                    </div>-->
                </div>

                <button title="Close" class="absolute top-0 right-0 mt-4 mr-4 e5-dropdown-close">
                    <!--                    {{!&#45;&#45; {{> components/icon/icon name="cross-light" classes="w-8 h-8 text-blue-500 stroke-current"}} &#45;&#45;}}-->
                </button>
            </div>
        </div><!-- /dropdown header -->

        <div class="pb-5 overflow-hidden overflow-y-auto">
            <!-- dropdown content -->
            <div class="e5-flatpickr-calendar-wrap">
                <!--                <div id="period-from-to"></div>-->
                <flat-pickr v-model="selectedDateRange" :config="flatpickrConfig"
                            @input="handleDateChange()"></flat-pickr>
            </div>

            <!--            calendar infotext start-->
            <div class="px-3 pt-5">
                <!--                <div class="flex items-center px-5 py-3 bg-gray-200 border-2 border-gray-200 rounded-base">-->
                <!--                <p class="flex text-sm leading-normal text-gray-600">-->
                <!--                    <strong>NB!</strong> &nbsp; Esimene võimalik väljumine on 11.02.2022. &nbsp; <strong><a class="hover:text-orange-400" href="#">Liigu kalendris!</a></strong>-->
                <!--                </p>-->
                <!--            </div>-->
            </div>
            <!--            calendar infotext end-->
        </div><!-- /dropdown content -->

    </div>
</template>

<script>
import FlatPickr from 'vue-flatpickr-component'

export default {
    name: 'DropDownCalendar',
    components: {
        FlatPickr
    },
    data () {
        return {
            selectedDateRange: null,
            flatpickrConfig: {
                showMonths: 1,
                mode: 'range',
                dateFormat: 'd.m.Y',
                inline: true,
                minDate: new Date().fp_incr(-10 * 365)
            }
        }
    },

    methods: {
        initializeFlatpickr () {
            if (window.matchMedia('(min-width: 1024px)').matches) {
                this.flatpickrConfig.showMonths = 2
            } else {
                this.flatpickrConfig.showMonths = 1
            }
        },
        handleDateChange () {
            if (this.selectedDateRange !== null) this.$emit('input', this.selectedDateRange)
        },
        resetAndReinitialize() {
            // Reset the selectedDateRange to null
            this.selectedDateRange = null;
        }
    },

    mounted () {
        this.initializeFlatpickr()
        window.addEventListener('resize', this.initializeFlatpickr)
        this.$root.$on('reset-calendar', () => {
            this.resetAndReinitialize();
        });
    },

    destroyed () {
        window.removeEventListener('resize', this.initializeFlatpickr)
    }
}
</script>

<style scoped>
.flatpickr-input {
    display: none;
}
</style>
